import React from 'react';
import './GettingStarted.css';

const GettingStarted = () => {
  return (
    <section className="getting-started">
      <div className="getting-started-container">
        <h2 className="getting-started-title">It's easy to get started with Aesthetic AI Receptionist</h2>
        <p className="getting-started-subtitle">Get started in as little as 20 minutes</p>
        
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h3 className="step-title">Integrate with your PMS</h3>
            <p className="step-description">
              1-click integration to your practice management software
            </p>
          </div>
          
          <div className="step">
            <div className="step-number">2</div>
            <h3 className="step-title">Configure Aesthetic AI Receptionist</h3>
            <p className="step-description">
              Our onboarding specialist will set up Aesthetic with your office information and preferences.
            </p>
          </div>
          
          <div className="step">
            <div className="step-number">3</div>
            <h3 className="step-title">Forward calls to Aesthetic</h3>
            <p className="step-description">
              Forward calls from any phone system to your Aesthetic number.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GettingStarted;
